// import Services from '@/services/index';
// import VT from '@/store/types';

export default {
  // [VT.SAMPLE_DELETE]: ({}, id) => {
  //   return new Promise((resolve, reject) => {
  //     Services.samples.delete(id).then((data) => {
  //       resolve(data);
  //     }).catch((data) => {
  //       reject(data);
  //     });
  //   });
  // },
};
